module.exports = __webpack_public_path__ + "img/ys-5.405b9e8d.svg";